import React from 'react';
import {HashRouter as Router,Routes,Route,Navigate} from 'react-router-dom';
import {AuthProvider,useAuth} from './contexts/AuthContext';
import {DataProvider} from './contexts/DataContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Members from './pages/Members';
import MemberDetail from './pages/MemberDetail';
import AddMember from './pages/AddMember';
import EditMember from './pages/EditMember';
import EditNote from './pages/EditNote';
import ManageCoaches from './pages/ManageCoaches';
import Settings from './pages/Settings';
import ProtectedRoute from './components/ProtectedRoute';
import InstallPrompt from './components/InstallPrompt';
import OfflineNotice from './components/OfflineNotice';
import UpdateNotice from './components/UpdateNotice';
import './App.css';

// Protected Settings Route that checks for Peter access
const ProtectedSettingsRoute=({children})=> {
  const {user}=useAuth();
  
  const isPeter=user?.system_role === 'superadmin';
  
  if (!isPeter) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

const ProtectedAllocatorRoute=({children})=> {
  const {user}=useAuth();
  return user?.system_role === 'superadmin' || user?.system_role === 'admin'
    ? children
    : <Navigate to="/" replace />;
};

function AppContent() {
  return (
    <Router>
      <OfflineNotice />
      <InstallPrompt />
      <UpdateNotice />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="members" element={<Members />} />
          <Route path="members/:memberId" element={<MemberDetail />} />
          <Route path="add-member" element={<AddMember />} />
          <Route path="edit-member/:memberId" element={<EditMember />} />
          <Route path="edit-note/:noteId/:memberId" element={<EditNote />} />
          <Route path="manage-coaches" element={<ProtectedAllocatorRoute><ManageCoaches /></ProtectedAllocatorRoute>} />
          <Route path="settings" element={
            <ProtectedSettingsRoute>
              <Settings />
            </ProtectedSettingsRoute>
          } />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <AppContent />
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
